module.exports = __webpack_public_path__ + "static/Manrope-Light-55aaaa1366df7c6544c2204b032a6e31.ttf";